/** @jsxImportSource @emotion/react */
import { useParams } from "react-router";
import { RouteFullScreenModal } from "../../../../components/RouteFullScreenModal";
import {
  useGetAdyenAccountHolder,
  useGetAdyenAccountHolderCapabilities,
} from "../../service/adyen-account-holders-api";
import { SpinnerBlock } from "../../../common/Spinner";
import "react18-json-view/src/style.css";
import JsonView from "react18-json-view";
import { css } from "@emotion/react";
import { ButtonInternalLink } from "../../../../components/NewButtons";
import { routes } from "../../../../appRoutingHelpers";
import { useSelector } from "react-redux";
import * as authSelectors from "../../../auth/authSelectors";
import { Divider } from "../../../../components/Divider";

export const bodyStyle = css`
  display: flex;
  flex-direction: column;
  gap: 32px;
  padding-top: 24px;
  padding-bottom: 24px;
  width: 100%;
  align-items: center;
  justify-content: start;
  overflow-y: auto;
`;

export const AccountHolderCapabilities = () => {
  const { id } = useParams();
  const organizationKeyName = useSelector(
    authSelectors.selectedOrganizationKeyName
  );
  const { data: accountHolder, isLoading } = useGetAdyenAccountHolder(id);
  const {
    data: capabilities,
    isLoading: isCapabilitiesLoading,
  } = useGetAdyenAccountHolderCapabilities(id, !!accountHolder?.reference);

  return (
    <RouteFullScreenModal
      title="Account holder capabilities"
      actions={
        <ButtonInternalLink
          to={
            accountHolder
              ? routes.adyenAccountHolder(organizationKeyName, accountHolder.id)
              : ".."
          }
        >
          Close
        </ButtonInternalLink>
      }
    >
      <Divider />
      {isLoading || isCapabilitiesLoading ? (
        <SpinnerBlock />
      ) : (
        <div css={bodyStyle}>
          <JsonView
            src={capabilities}
            css={css`
              width: 100%;
              max-width: 600px;
            `}
          />
        </div>
      )}
    </RouteFullScreenModal>
  );
};
